import * as R from "ramda";
import React, { useContext } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Typography } from "@mui/material";
import { Title } from "components/Typography";
import { LanguageContext } from "contexts/language.context";
import { Translate } from "utils/translate";
import WorkCard from "./WorkCard";

const Work = () => {
  const { language } = useContext(LanguageContext);

  const { years, data } = R.pipe(R.groupBy(R.prop("year")), (o) =>
    R.zipObj(["years", "data"], [R.reverse(R.keys(o)), o])
  )(Translate(language, ["WORK", "data"]));

  return (
    <div>
      <Title variant="h5">{Translate(language, ["WORK", "title"])}</Title>
      <Timeline position="alternate">
        {years.map((year, index) => (
          <TimelineItem key={`timelineitem-${index}`}>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography gutterBottom variant="h5">
                {year}
              </Typography>
              {data[year].map((value, index) => (
                <WorkCard key={`workcard-${index}`} {...value} />
              ))}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
};

export default Work;
